import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { Button } from "@mui/material";
import type { FC } from "react";
import { useSavedOrderToProducts } from "../orders/orderEdit/orderToProducts";
import type { SavedOrder } from "../orders/orderTypes";

interface Props {
  readonly order: Pick<SavedOrder, "products" | "currency" | "currencyExchangeRate">;
  readonly onClick: () => void;
}

const GoToParticipantListButton: FC<Props> = ({ order, onClick }) => {
  const { products, isLoading: areProductsLoading } = useSavedOrderToProducts(order);
  const listRequired =
    !areProductsLoading &&
    products.length > 0 &&
    products.some((p) => p.options.some((o) => o.participantListRequired));
  if (!listRequired) {
    return null;
  }
  return (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<FormatListBulletedIcon />}
      sx={{ width: { xs: "100%", sm: "auto" } }}
      onClick={onClick}
    >
      Lista uczestników
    </Button>
  );
};

export default GoToParticipantListButton;
